import "./JudgeInputBoutDialog.scss";

import Dialog from "../1. Core/Controls/Dialog/Dialog";
import NP, {IHash} from "../1. Core/NP";
import Label from "../1. Core/Controls/Label/Label";
import Button from "../1. Core/Controls/Button/Button";
import {secondsToTime} from "../10. Battle/Util";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListBox, {ListBoxItemArgs} from "../1. Core/Controls/ListBox/ListBox";
import {IItem} from "../1. Core/Controls/ListBox/ListItem";
import Select, {ISelectItemArgs} from "../1. Core/Controls/Select/Select";
import {IBattle} from "../10. Battle/types";


let moment = require('moment');

type ExtraPointsData = {
	[key: string]: { [key: string]: number }
}

interface Judge {
	FirstName: string,
	LastName: string,
	Id: number
}


/**
 * Через этот диалог судья вводит свои оценки и данные в базу
 */
export class JudgeInputBoutDialog extends Dialog {
	private _redLabel: Label;
	private _blueLabel: Label;
	private _roundLabel: Label;
	private _Battle: IBattle;
	private _localTimeLabel: Label;
	private _serverTimeLabel: Label;

	private _startDate: Date;
	private _round: number;

	private _timeInterval: any;

	private _endRound: Button;
	private _startBtn: Button;
	private _blueMinusBtn: Button;
	private _bluePenBtn: Button;
	private _bluePlusBtn: Button;
	private _redMinusBtn: Button;
	private _redPenBtn: Button;
	private _redPlusBtn: Button;
	private _redDamageBtn: Button;
	private _redDomBtn: Button;
	private _redOtherBtn: Button;
	private _blueDamageBtn: Button;
	private _blueDomBtn: Button;
	private _blueOtherBtn: Button;
	private _extraButtonsNode: HTMLElement;
	private _roundPointsBtn: Button;
	private _red10Points: Button;
	private _red9Points: Button;
	private _red8Points: Button;
	private _blue9Points: Button;
	private _blue10Points: Button;
	private _roundPointsNode: HTMLElement;
	private _mainPointsNode: HTMLElement;
	private _blue8Points: Button;

	private _nextRoundBtn: Button;

	private _endBattleBtn: Button;
	private _pointsChartNode: HTMLElement;
	private _redPointCount: number;
	private _bluePointCount: number;
	private _sumTableNode: HTMLElement;
	private _clearData: Button;
	private _showPureData: Button;

	private _pureDataTableNode: HTMLElement;
	private _pauseBtn: Button;
	private _isPaused: boolean;
	private _startTimePause: Date;
	private _pauseSec: number;

	private _tempExtraPoints: ExtraPointsData;

	private _penaltyInfo: JudgeBattlePointsRow[];

	private _judgeBattlePoints: JudgeBattlePoints;

	private _redPenaltyList: ListBox;
	private _bluePenaltyList: ListBox;
	private _judgeSelectBox: Select;

	_initFields(settings: object)
	{

		this._Battle = null;

		super._initFields(settings);

		this._round = 0;
		this._AutoDestroy = true;
		this._Mode = 'FullScreen';
		this._Caption = "Judge points";
		this._CloseOnFrameMouseDown = false;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = false;
		this._UseSinglePaddingContent = false;
		this._FlexContent = true;

	}

	_render()
	{
		super._render();
		this.addClass('nopad battle-statistics-dialog judge-points-dlg');

		NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
		NP.addCssClass(this._container, 'dialog__container--fullscreen');

		let boutInfoNode = NP.createNode(this._contentNode, 'bout-info');

		let judgeInfo = NP.createNode(boutInfoNode, 'bout-info__row judge-dlg-first-row');

		new Label({
			ParentNode: judgeInfo,
			MultiLine: true,
			Content: NP.getCurrentUser().getViewName()
		});


		new Label({
			ParentNode: judgeInfo,
			MultiLine: true,
			Content: NP.escapeHTML(this._Battle.Tournament)
		});


		new Label({
			ParentNode: judgeInfo,
			MultiLine: true,
			Content: this._Battle.Date ? moment(this._Battle.Date).format(NP.getDayFormat()) : "",
		});

		let boutInfoNodeSecondRow = NP.createNode(boutInfoNode, 'bout-info__row');
		this._redLabel = new Label({
			ParentNode: boutInfoNodeSecondRow,
			Class: 'bout-info__row__item bout-info__row__item__red',
			MultiLine: true,
			Content: this._Battle.RedName
		});
		this._blueLabel = new Label({
			ParentNode: boutInfoNodeSecondRow,
			Class: 'bout-info__row__item bout-info__row__item__blue',
			MultiLine: true,
			Content: this._Battle.BlueName
		});

		//-------------------------------------
		let roundParent = NP.createNode(boutInfoNode, 'bout-info__row');


		this._startBtn = new Button({
			RK: 'Start',
			ParentNode: roundParent,
			Class: 'app-button--raised green-btn',
			EvClick: () => this._isPaused ? this.resume() : this.startBattle(this._round + 1)
		});

		this._pauseBtn = new Button({
			RK: 'Pause',
			Enabled: false,
			ParentNode: roundParent,
			Class: 'app-button--raised green-btn',
			EvClick: () => this.pause()
		});

		this._pauseBtn.getRoot().style.marginLeft = '16px';

		this._roundLabel = new Label({
			ParentNode: roundParent,
			Class: 'bout-info__row__item',
			Content: 'Раунд'
		});

		this._localTimeLabel = new Label({
			ParentNode: roundParent,
			Class: 'bout-info__row__item',
			Content: '00:00'
		});


		this._serverTimeLabel = new Label({
			ParentNode: roundParent,
			Class: 'bout-info__row__item',
			Content: '00:00'
		});

		//-------------------------------------

		this._mainPointsNode = NP.createNode(this._contentNode, 'action-buttons');


		let redButtonsNode = NP.createNode(this._mainPointsNode, 'red-judge-buttons');

		this._redPlusBtn = new Button({
			Content: '+1',
			Width: NP.IsTouch ? 150 : 300,
			Height: NP.IsTouch ? 100 : 200,
			ParentNode: redButtonsNode,
			Class: 'app-button--raised big-btn-plus-1',
			EvClick: (btn: Button) =>
			{
				this.addPoints(this._Battle.Red, 1)
				this.updateCountBtn(btn)
			}
		});

		this._br(redButtonsNode);

		this._redPenBtn = new Button({
			RK: 'Penalty',
			Width: 70,
			ParentNode: redButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this._penaltyInfo.push({
					AthleteId: this._Battle.Red,
					Time: this.getCurrentTimeInSeconds(),
					Points: 0,
					Desc: 'Penalty',
					Round: this._round,
					GPTime: this._serverTimeLabel.getData() / 1000
				});
				this.updateCountBtn(btn)
			}
		});

		this._redMinusBtn = new Button({
			Content: '-1',
			Width: 80,
			ParentNode: redButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPoints(this._Battle.Red, -1)
				this.updateCountBtn(btn)
			}
		});


		let blueButtonsNode = NP.createNode(this._mainPointsNode, 'blue-judge-buttons');


		this._bluePlusBtn = new Button({
			Content: '+1',
			Width: NP.IsTouch ? 150 : 300,
			Height: NP.IsTouch ? 100 : 200,
			ParentNode: blueButtonsNode,
			Class: 'app-button--raised big-btn-plus-1',
			EvClick: (btn: Button) =>
			{
				this.addPoints(this._Battle.Blue, 1)
				this.updateCountBtn(btn)
			}
		});

		this._br(blueButtonsNode);


		this._bluePenBtn = new Button({
			RK: 'Penalty',
			Width: 70,
			ParentNode: blueButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this._penaltyInfo.push({
					AthleteId: this._Battle.Blue,
					Time: this.getCurrentTimeInSeconds(),
					Points: 0,
					Desc: 'Penalty',
					Round: this._round,
					GPTime: this._serverTimeLabel.getData() / 1000
				});
				this.updateCountBtn(btn)
			}
		});

		this._blueMinusBtn = new Button({
			Content: '-1',
			Width: 80,
			ParentNode: blueButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPoints(this._Battle.Blue, -1)
				this.updateCountBtn(btn)
			}
		});


		//-------------------------------------Extra points buttons --------------------------------------------------


		this._extraButtonsNode = NP.createNode(this._contentNode, 'action-buttons');


		let redExtraButtonsNode = NP.createNode(this._extraButtonsNode, 'red-judge-buttons judge-extra-actions');

		this._redDamageBtn = new Button({
			RK: 'Damage',
			Value: 'Damage',
			Width: 180,
			ParentNode: redExtraButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPointsFromStep2(this._Battle.Red, btn)
			}
		});

		this._br(redExtraButtonsNode);

		this._redDomBtn = new Button({
			RK: 'Dominance',
			Value: 'Dominance',
			Width: 180,
			ParentNode: redExtraButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPointsFromStep2(this._Battle.Red, btn)
			}
		});

		this._br(redExtraButtonsNode);

		this._redOtherBtn = new Button({
			RK: 'Other',
			Value: 'Other',
			Width: 180,
			ParentNode: redExtraButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPointsFromStep2(this._Battle.Red, btn)
			}
		});


		let blueExtraButtonsNode = NP.createNode(this._extraButtonsNode, 'blue-judge-buttons judge-extra-actions');

		this._blueDamageBtn = new Button({
			RK: 'Damage',
			Value: 'Damage',
			Width: 180,
			ParentNode: blueExtraButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPointsFromStep2(this._Battle.Blue, btn)
			}
		});

		this._br(blueExtraButtonsNode);

		this._blueDomBtn = new Button({
			RK: 'Dominance',
			Value: 'Dominance',
			Width: 180,
			ParentNode: blueExtraButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPointsFromStep2(this._Battle.Blue, btn)
			}
		});

		this._br(blueExtraButtonsNode);

		this._blueOtherBtn = new Button({
			RK: 'Other',
			Value: 'Other',
			Width: 180,
			ParentNode: blueExtraButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) =>
			{
				this.addPointsFromStep2(this._Battle.Blue, btn)
			}
		});


		//-----------------------------Round points------------------------------------------------


		this._roundPointsNode = NP.createNode(this._contentNode);
		this._roundPointsNode.style.textAlign = 'center';

		this._pointsChartNode = NP.createNode(this._roundPointsNode, 'judge-round-points-chart');
		this._pointsChartNode.innerHTML = "<div class='point-chart-item' red></div><div class='point-chart-item' blue></div>";

		let pointsCont = NP.createNode(this._roundPointsNode, 'action-buttons');

		let redRoundPointsButtonsNode = NP.createNode(pointsCont, 'red-judge-buttons judge-extra-actions');

		this._red10Points = new Button({
			Content: '10',
			Data: 10,
			Width: 180,
			ParentNode: redRoundPointsButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) => this.roundRedPointBtnClick(btn)
		});

		this._br(redRoundPointsButtonsNode);

		this._red9Points = new Button({
			Content: '9',
			Data: 9,
			Width: 180,
			ParentNode: redRoundPointsButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) => this.roundRedPointBtnClick(btn)
		});

		this._br(redRoundPointsButtonsNode);

		this._red8Points = new Button({
			Content: '8',
			Data: 8,
			Width: 180,
			ParentNode: redRoundPointsButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) => this.roundRedPointBtnClick(btn)
		});


		this._br(redRoundPointsButtonsNode);
		new Label({ParentNode: redRoundPointsButtonsNode, Content: 'Penalty list'});
		this._br(redRoundPointsButtonsNode);
		this._redPenaltyList = new ListBox({
			ParentNode: redRoundPointsButtonsNode,
			Width: NP.IsTouch ? 150 : 200,
			EvDeletedClick: (list: ListBox, e: ListBoxItemArgs) =>
			{
				list.removeItem(e.Item);
				if (!list.getItems().length)
					this._red10Points.setEnabled(true);
			}
		});


		let blueRoundPointsButtonsNode = NP.createNode(pointsCont, 'blue-judge-buttons judge-extra-actions');

		this._blue10Points = new Button({
			Content: '10',
			Data: 10,
			Width: 180,
			ParentNode: blueRoundPointsButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) => this.roundBluePointBtnClick(btn)
		});

		this._br(blueRoundPointsButtonsNode);

		this._blue9Points = new Button({
			Content: '9',
			Data: 9,
			Width: 180,
			ParentNode: blueRoundPointsButtonsNode,
			Class: 'app-button--raised'
			,
			EvClick: (btn: Button) => this.roundBluePointBtnClick(btn)
		});

		this._br(blueRoundPointsButtonsNode);

		this._blue8Points = new Button({
			Content: '8',
			Data: 8,
			Width: 180,
			ParentNode: blueRoundPointsButtonsNode,
			Class: 'app-button--raised',
			EvClick: (btn: Button) => this.roundBluePointBtnClick(btn)
		});


		this._br(blueRoundPointsButtonsNode);
		new Label({ParentNode: blueRoundPointsButtonsNode, Content: 'Penalty list'});
		this._br(blueRoundPointsButtonsNode);
		this._bluePenaltyList = new ListBox({
			ParentNode: blueRoundPointsButtonsNode,
			Width: NP.IsTouch ? 150 : 200,
			EvDeletedClick: (list: ListBox, e: ListBoxItemArgs) =>
			{
				list.removeItem(e.Item);
				if (!list.getItems().length)
					this._blue10Points.setEnabled(true);
			}
		});


		this._sumTableNode = NP.createNode(this._contentNode, 'judge-point-tbl-parent');

		this._pureDataTableNode = NP.createNode(this._contentNode, 'judge-point-tbl-parent');

		//-------------------------------------End buttons --------------------------------------------------

		let extraNode = NP.createNode(this._contentNode, 'judge-extra-node');

		if (NP.IsTouch)
			NP.addCssClass(extraNode, 'judge-extra-node--touch');

		this._endRound = new Button({
			RK: 'EndRound',
			IsVisible: false,
			Class: 'judge-extra-btn',
			Width: 150,
			ParentNode: extraNode,
			EvClick: () =>
			{
				this._pauseBtn.setEnabled(false);
				this._endRound.setIsVisible(false);

				NP.setIsVisible([this._extraButtonsNode, this._roundPointsBtn], true);
				[this._redDamageBtn, this._redOtherBtn, this._redDomBtn, this._blueDamageBtn, this._blueOtherBtn, this._blueDomBtn].forEach(b =>
				{
					b.setEnabled(true);
					b.removeClass('app-button--pressed');
				});

				ServerAPI.post(`/judge/addJudgePoint/${this._Battle.Id}`, {
					Round: this._round,
					JudgeId: NP.getCurrentUser().getKey(),
					Time: this.getCurrentTimeInSeconds(),
					Desc: 'End round'
				});

				this._startBtn.setEnabled(true);
				clearInterval(this._timeInterval);
				this._localTimeLabel.setContent("00:00");
				this._serverTimeLabel.setContent("00:00");

				this.setPointsButtonsVisible(false);
			}
		});

		this._roundPointsBtn = new Button({
			RK: 'RoundPoints',
			Class: 'judge-extra-btn',
			Width: 150,
			IsVisible: false,
			ParentNode: extraNode,
			EvClick: async () =>
			{
				NP.setIsVisible([this._extraButtonsNode, this._roundPointsBtn], false);

				this.showTotalRoundPointsStep();

				await this.saveExtraPoints();

				this._nextRoundBtn.setEnabled(false);

				if (this._penaltyInfo.find(p => p.AthleteId == this._Battle.Red))
					this._red10Points.setEnabled(false);

				if (this._penaltyInfo.find(p => p.AthleteId == this._Battle.Blue))
					this._blue10Points.setEnabled(false);

				this.refreshChartPoint();
			}
		});

		this._nextRoundBtn = new Button({
			RK: 'NextRound',
			Class: 'judge-extra-btn',
			Width: 150,
			IsVisible: false,
			ParentNode: extraNode,
			EvClick: () =>
			{
				this.startBattle(this._round + 1);
			}
		});

		this._endBattleBtn = new Button({
			RK: 'BoutEnd',
			Class: 'judge-extra-btn judge-bout-end-btn',
			Width: 150,
			IsVisible: false,
			ParentNode: extraNode,
			EvClick: async () =>
			{
				await this.saveCurrentRoundPoints();
				this.checkData()
			}
		});

		if (NP.isAdmin())
			this._clearData = new Button({
				RK: 'Clear',
				Class: 'judge-extra-btn judge-bout-end-btn',
				Width: 150,
				IsVisible: false,
				ParentNode: extraNode,
				EvClick: () =>
				{
					NP.showConfirm({
						RK: 'AreYouS',
						EvOkButtonClick: async () =>
						{
							this._round = 0;
							this._isPaused = false;
							this.createEmptyData();
							this._clearData.setIsVisible(false);
							this._sumTableNode.innerHTML = '';
							this._pureDataTableNode.innerHTML = '';
							await ServerAPI.post(`/judge/clearJudgeBattlePoints/${this._Battle.Id}`);
							this._startBtn.setEnabled(true);
							this._judgeSelectBox.setIsVisible(false);
							if (this._showPureData)
								this._showPureData.setIsVisible(false);
						}
					})
				}
			});

		this._showPureData = new Button({
			RK: 'ShowData',
			Class: 'judge-extra-btn judge-bout-end-btn',
			Width: 150,
			IsVisible: false,
			ParentNode: extraNode,
			EvClick: () =>
			{
				if (this._pureDataTableNode.innerHTML)
					this._pureDataTableNode.innerHTML = '';
				else
					this.renderPureData();
			}
		});

		NP.setIsVisible([this._extraButtonsNode, this._roundPointsNode, this._roundPointsBtn, this._mainPointsNode, this._okButton, this._showPureData], false);

		this._judgeSelectBox = new Select({
			Width: 300,
			EvItemSelected: (s: object, e: ISelectItemArgs) =>
			{
				this.renderJudgeData(e.Item.Value);
				if (this._pureDataTableNode.innerHTML)
					this.renderPureData();
			}
		});

		this._judgeSelectBox.getRoot().style.marginLeft = 'calc(50% - 150px)';

		this._judgeSelectBox.putToNode(this._contentNode, this._sumTableNode);
		this._startBtn.setEnabled(false);

		this.checkData();
	}

	showTotalRoundPointsStep()
	{
		NP.setIsVisible([this._roundPointsNode, this._nextRoundBtn], true);
		[this._red10Points, this._red9Points, this._red8Points, this._blue10Points, this._blue9Points, this._blue8Points].forEach(b =>
			 {
				 b.setEnabled(true);
				 b.setTag(null);
				 b.removeClass('app-button--pressed');
			 }
		);

		this._redPenaltyList.clear();
		this._bluePenaltyList.clear();

		this._penaltyInfo.forEach(p =>
		{
			let item = {
				Content: secondsToTime(p.Time),
				Value: p,
				ShowDeleteButton: true
			} as IItem;

			if (p.AthleteId == this._Battle.Red)
				this._redPenaltyList.addItem(item);
			else
				this._bluePenaltyList.addItem(item);
		})
	}

	createEmptyData()
	{
		this._judgeBattlePoints = {
			BattlePointsRowData: {Rows: []},
			BattlePointsInfo: {
				RedPoints: {},
				BluePoints: {}
			},
			BattleRoundPointsInfo: {
				RedPoints: {},
				BluePoints: {}
			}
		}
	}

	checkData()
	{
		ServerAPI.get(`/judge/getJudgesOfBattlePoints/${this._Battle.Id}`).then((res: Judge[]) =>
		{
			if (res.length)
			{
				this._judgeSelectBox.setIsVisible(true);
				this._judgeSelectBox.setItems(res.map(j => ({
					Content: j.FirstName + " " + (j.LastName || ''),
					Value: j.Id
				})));

				this._judgeSelectBox.setSelectedIndex(0, false);
				this.renderJudgeData(res[0].Id);
				if (this._showPureData)
					this._showPureData.setIsVisible(true)
			}
			else
			{
				if (this._showPureData)
					this._showPureData.setIsVisible(false)
				this._judgeSelectBox.setIsVisible(false);
				this._startBtn.setEnabled(true);
				this.createEmptyData();
			}
		});
	}

	renderJudgeData(judgeId: number)
	{
		ServerAPI.get(`/judge/getJudgeBattlePoints/${this._Battle.Id}/${judgeId}`).then((res: JudgeBattlePoints) =>
		{
			let hasData = res.BattlePointsRowData.Rows.length > 0;

			if (hasData)
				this.endButtle(res);
		});
	}


	endButtle(res: JudgeBattlePoints)
	{
		this.saveCurrentRoundPoints();
		NP.setIsVisible([this._extraButtonsNode, this._roundPointsNode, this._roundPointsBtn, this._mainPointsNode, this._endRound, this._nextRoundBtn, this._endBattleBtn], false);
		clearInterval(this._timeInterval);
		this._startBtn.setEnabled(false);
		this._pauseBtn.setEnabled(false);
		if (this._clearData)
			this._clearData.setIsVisible(true);
		if (this._showPureData)
			this._showPureData.setIsVisible(true);
		this.renderSumTable(res);
		this._judgeBattlePoints = res;
	}


	renderSumTable(data: JudgeBattlePoints)
	{
		this._sumTableNode.innerHTML = '';

		let rows = [["", this._Battle.RedName, this._Battle.BlueName]];
		let rsum = 0, bsum = 0;
		for (let r in data.BattleRoundPointsInfo.BluePoints)
		{
			let rp = data.BattleRoundPointsInfo.RedPoints[r] || 0;
			let bp = data.BattleRoundPointsInfo.BluePoints[r] || 0;

			let ro = data.BattlePointsInfo.RedPoints[r] || 0;
			let bo = data.BattlePointsInfo.BluePoints[r] || 0;

			rsum += rp;
			bsum += bp;

			if (rp > bp)
			{
				//@ts-ignore
				rp = `<b>${rp}</b>`
			}
			else
				 //@ts-ignore
				bp = `<b>${bp}</b>`


			rows.push([NP.RM.getString("Round") + r, `${rp} (${ro})`, `${bp} (${bo})`]);

		}

		rows.push(["<b>" + NP.RM.getString("sum") + "</b>", rsum + "", bsum + ""]);

		let rhtml = rows.map(a => a.map(i => `<td>${i}</td>`).join(''))
			 .map(s => `<tr>${s}</tr>`).join('')

		let tbl = NP.parseHTMLC(`<table cellpadding="5" cellspacing="5"><tbody>${rhtml}</tbody></table>`);

		this._sumTableNode.appendChild(tbl);

	}


	renderPureData()
	{
		this._pureDataTableNode.innerHTML = '';


		let rhtml = this._judgeBattlePoints.BattlePointsRowData.Rows.map(a => `
<td>${a.Round}</td> 
<td>${secondsToTime(a.Time)}</td>
<td>${secondsToTime(a.GPTime)}</td>
<td>${a.AthleteId == this._Battle.Red ? 'Red' : 'Blue'}</td> 
<td>${a.Points}</td> 
<td>${a.Desc || ''}</td>`)
			 .map(s => `<tr>${s}</tr>`).join('');

		this._pureDataTableNode.innerHTML = `<table cellpadding="5" cellspacing="5"><tbody><tr><td>Round</td><td>Time</td><td>GP Time</td><td>Athlete</td><td>Points</td><td>Desc</td></tr> ${rhtml}</tbody></table>`
	}


	roundRedPointBtnClick(btn: Button)
	{
		let p = this._judgeBattlePoints.BattleRoundPointsInfo.RedPoints;
		if (p[this._round])
		{
			[this._red10Points, this._red9Points, this._red8Points].forEach(b => b.setEnabled(true));
			delete p[this._round];

			if (this._redPenaltyList.getItems().length)
				this._red10Points.setEnabled(false);

			this._nextRoundBtn.setEnabled(false);

			return;
		}

		[this._red10Points, this._red9Points, this._red8Points].forEach(b => b != btn && b.setEnabled(false));


		if (this._judgeBattlePoints.BattleRoundPointsInfo.BluePoints[this._round] && this._round < this._Battle.RoundCount)
			this._nextRoundBtn.setEnabled(true);


		p[this._round] = btn.getData();

	}

	roundBluePointBtnClick(btn: Button)
	{
		let p = this._judgeBattlePoints.BattleRoundPointsInfo.BluePoints;

		if (p[this._round])
		{
			[this._blue10Points, this._blue9Points, this._blue8Points].forEach(b => b.setEnabled(true));
			delete p[this._round];

			if (this._bluePenaltyList.getItems().length)
				this._blue10Points.setEnabled(false);

			this._nextRoundBtn.setEnabled(false);
			return;
		}


		[this._blue10Points, this._blue9Points, this._blue8Points].forEach(b => b != btn && b.setEnabled(false));


		if (this._judgeBattlePoints.BattleRoundPointsInfo.RedPoints[this._round] && this._round < this._Battle.RoundCount)
			this._nextRoundBtn.setEnabled(true);


		p[this._round] = btn.getData();
	}


	getExtraPointOppositeButton(athleteId: number, btn: Button): Button
	{
		if (athleteId == this._Battle.Blue)
			return [this._redDamageBtn, this._redOtherBtn, this._redDomBtn].find(b => b.getValue() == btn.getValue())
		else
			return [this._blueDamageBtn, this._blueOtherBtn, this._blueDomBtn].find(b => b.getValue() == btn.getValue())
	}

	/**
	 * Довляет очки в тепмовое хранилище от кнопок ущерб, доминирование, прочее.
	 * На сервер не посылает, чтобы можно было отменить
	 */
	addPointsFromStep2(athleteId: number, btn: Button)
	{

		let type = btn.getValue() as string;
		let value = 1;
		switch (type)
		{
			case 'Damage':
				value = 3;
				break;
			case 'Dominance':
				value = 2;
				break;
		}

		this.getExtraPointOppositeButton(athleteId, btn).setEnabled(!!btn.getTag());

		if (btn.getTag())
		{
			btn.removeClass('app-button--pressed');
			btn.setTag(null);
			if (this._tempExtraPoints[athleteId])
				delete this._tempExtraPoints[athleteId][type];
		}
		else
		{
			btn.addClass('app-button--pressed');
			btn.setTag('Pressed');

			if (!this._tempExtraPoints[athleteId])
				this._tempExtraPoints[athleteId] = {[type]: value};
			else
				this._tempExtraPoints[athleteId][type] = value;
		}
	}

	async saveExtraPoints()
	{
		for (let athleteId in this._tempExtraPoints)
		{
			for (let type in this._tempExtraPoints[athleteId])
				await this.addPoints(athleteId as unknown as number, this._tempExtraPoints[athleteId][type], type)
		}
	}

	async addPoints(athleteId: number, points: number, type?: string)
	{
		if (athleteId == this._Battle.Blue)
			this._bluePointCount += points;
		else
			this._redPointCount += points;

		await ServerAPI.post(`/judge/addJudgePoint/${this._Battle.Id}`,
			 {
				 Round: this._round,
				 JudgeId: NP.getCurrentUser().getKey(),
				 Time: this.getCurrentTimeInSeconds(),
				 Points: points,
				 AthleteId: athleteId,
				 Desc: type
			 });
	}

	clearCountBtns()
	{
		[this._redPlusBtn, this._redMinusBtn, this._redPenBtn,
			this._bluePlusBtn, this._blueMinusBtn, this._bluePenBtn].forEach(b =>
		{
			if (b.getTag())
			{
				b.setData(0);
				b.setContent(b.getTag());
			}
		})
	}

	updateCountBtn(btn: Button)
	{
		let count = btn.getData();
		if (!count)
			count = 1;
		else
			count++;


		let cnt = btn.getRK() ? NP.RM.getString(btn.getRK()) : null;
		if (!cnt)
		{
			if (!btn.getTag())
				btn.setTag(btn.getContent());

			cnt = btn.getTag();
		}
		else
			btn.setTag(cnt);

		btn.setContent(`${cnt} (${count})`);
		btn.setData(count);
	}

	getCurrentTimeInSeconds()
	{
		return Math.floor(((new Date()).getTime() - this._startDate.getTime()) / 1000) - this._pauseSec;
	}


	async updateTimeLabel()
	{
		this._localTimeLabel.setContent(secondsToTime(this.getCurrentTimeInSeconds()));
		let serverMilliSeconds = await ServerAPI.get(`/battle/getCurrentBattleTime/current`) as number;
		this._serverTimeLabel.setContent(secondsToTime(serverMilliSeconds / 1000));
		this._serverTimeLabel.setData(serverMilliSeconds);
	}

	setPointsButtonsVisible(value: boolean)
	{
		NP.setIsVisible(this._mainPointsNode, value);
	}


	pause()
	{
		clearInterval(this._timeInterval);
		this.setPointsButtonsVisible(false);
		this._isPaused = true;
		this._startBtn.setEnabled(true);
		this._pauseBtn.setEnabled(false);
		this._startTimePause = new Date();
	}

	resume()
	{
		this._pauseSec += ((new Date()).getTime() - this._startTimePause.getTime()) / 1000;
		this.setPointsButtonsVisible(true);
		this._timeInterval = setInterval(() => this.updateTimeLabel(), 1000);
		this._isPaused = false;
		this._startBtn.setEnabled(false);
		this._pauseBtn.setEnabled(true);
	}

	async saveCurrentRoundPoints()
	{
		if (this._round)
		{
			if (this._judgeBattlePoints.BattleRoundPointsInfo.BluePoints[this._round])
			{
				await ServerAPI.post(`/judge/addJudgeRoundPoint/${this._Battle.Id}`, {
					Round: this._round,
					JudgeId: NP.getCurrentUser().getKey(),
					Points: this._judgeBattlePoints.BattleRoundPointsInfo.BluePoints[this._round],
					AthleteId: this._Battle.Blue
				});
			}

			if (this._judgeBattlePoints.BattleRoundPointsInfo.RedPoints[this._round])
			{
				await ServerAPI.post(`/judge/addJudgeRoundPoint/${this._Battle.Id}`, {
					Round: this._round,
					JudgeId: NP.getCurrentUser().getKey(),
					Points: this._judgeBattlePoints.BattleRoundPointsInfo.RedPoints[this._round],
					AthleteId: this._Battle.Red
				});
			}

			delete this._judgeBattlePoints.BattleRoundPointsInfo.BluePoints[this._round];
			delete this._judgeBattlePoints.BattleRoundPointsInfo.RedPoints[this._round];


			for (let item of [...this._redPenaltyList.getItems(), ...this._bluePenaltyList.getItems()])
			{
				let p = item.getValue() as JudgeBattlePointsRow;
				await ServerAPI.post(`/judge/addJudgePenalty/${this._Battle.Id}`, {
					Round: this._round,
					JudgeId: NP.getCurrentUser().getKey(),
					Time: p.Time,
					AthleteId: p.AthleteId
				});
			}

		}
	}

	async startBattle(round = 1)
	{
		await this.saveCurrentRoundPoints();

		this._pauseSec = 0;
		this._redPointCount = 0;
		this._bluePointCount = 0;

		NP.setIsVisible([this._extraButtonsNode, this._roundPointsNode, this._roundPointsBtn, this._nextRoundBtn], false);
		this._endRound.setIsVisible(true);
		this._endBattleBtn.setIsVisible(true);
		this._startBtn.setEnabled(false);
		this._pauseBtn.setEnabled(true);

		this._tempExtraPoints = {} as any;
		this._penaltyInfo = [];

		this.clearCountBtns();
		this.setPointsButtonsVisible(true);
		this._round = round;
		this._roundLabel.setContent(NP.RM.getString("Round") + " " + round);
		this._startDate = new Date();
		this._timeInterval = setInterval(() => this.updateTimeLabel(), 1000);
	}

	refreshChartPoint()
	{
		let redValue = Math.floor(100 * this._redPointCount / (this._redPointCount + this._bluePointCount));

		let redNode = (this._pointsChartNode.querySelector('.point-chart-item[red]') as HTMLElement);
		redNode.style.width = redValue + '%';
		redNode.innerText = this._redPointCount + '';

		let blueNode = (this._pointsChartNode.querySelector('.point-chart-item[blue]') as HTMLElement);
		blueNode.style.width = (100 - redValue) + '%';
		blueNode.innerText = this._bluePointCount + '';
	}

	hide()
	{
		NP.showConfirm({
			RK: 'AreYouS',
			EvOkButtonClick: () =>
			{
				clearInterval(this._timeInterval);
				super.hide();
			}
		});
	}
}

interface JudgeBattlePointsRow {
	Time: number;
	GPTime: number;
	Points: number;
	Round: number;
	Desc: string;
	AthleteId: number;
}

interface BattlePointsRowData {
	Rows: JudgeBattlePointsRow[];
}

interface BattlePointsInfo {
	RedPoints: IHash<number>;
	BluePoints: IHash<number>;
}

interface BattleRoundPointsInfo {
	RedPoints: IHash<number>;
	BluePoints: IHash<number>;
}

interface JudgeBattlePoints {
	BattlePointsRowData: BattlePointsRowData;
	BattlePointsInfo: BattlePointsInfo;
	BattleRoundPointsInfo: BattleRoundPointsInfo;
}
